// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { useEffect, useRef } from 'react';
export var COMPONENT_METADATA_KEY = '__awsuiMetadata__';
export function useComponentMetadata(componentName, packageVersion, componentConfiguration) {
    var elementRef = useRef(null);
    useEffect(function () {
        if (elementRef.current) {
            var node = elementRef.current;
            var metadata = { componentConfiguration: componentConfiguration, name: componentName, version: packageVersion };
            Object.freeze(metadata);
            Object.defineProperty(node, COMPONENT_METADATA_KEY, { value: metadata, writable: false, configurable: true });
        }
    });
    return elementRef;
}
